module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-13.c8672dfb.svg";